import type { HelpCenterContext } from 'state/helpRequest/state';

export const helpCenterActions = {
  open(id: string, context?: HelpCenterContext) {
    return { type: 'HELP_CENTER_OPEN' as const, id, context };
  },
  close() {
    return { type: 'HELP_CENTER_CLOSE' as const };
  },
  updateContext(id: string, context: HelpCenterContext) {
    return { type: 'HELP_CENTER_UPDATE_CONTEXT' as const, id, context };
  },
  openTopic(topicId: string) {
    return { type: 'HELP_CENTER_TOPIC_OPEN' as const, topicId };
  },
};

type HelpCenterActionsType = typeof helpCenterActions;
export type HelpCenterActions = ReturnType<HelpCenterActionsType[keyof HelpCenterActionsType]>;
